import './modal-youtube.scss';

export class ModalYoutube {

  constructor() {
    this.cookieStatus = true;
    this.videoBlockedMessage = '.paragraph--type--video .paragraph-video-container-disabled'
    this.triggerEl = '[data-youtube]';
    this.modalSelector = '#modalyoutube';
    this.player = {};

    window.addEventListener('DOMContentLoaded', (event) => {
      const self = this;
      window.setTimeout(() => {
        OneTrust.OnConsentChanged(function () {
          self.loadYoutubeApi();
        });
        self.init();
      }, 1000);
    });
  }

  init = () => {
    document.querySelector(this.modalSelector).addEventListener('hide.bs.modal', () => this.player.pauseVideo());

    this.loadYoutubeApi();
    this.onYouTubePlayerAPIReady();

    const triggers = document.querySelectorAll(this.triggerEl);
    triggers.forEach(trigger => {
      if (trigger.dataset.youtube === '') return false;

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.cookieStatus) {
          this.openModal(trigger);
        }
      });
    })
  };

  openModal = (trigger) => {
    const videoId = this.retrieveYoutubeId(trigger.dataset.youtube);
    if (videoId) {
      const modalEl = document.querySelector(this.modalSelector);
      if (!modalEl) return false;

      const isPaused = this.player && this.player.getPlayerState() === 2 && videoId === this.player.getVideoData()['video_id'];
      if (!isPaused) {
        this.initYoutubeVideo(videoId);
      }

      const modal = new window.modal(modalEl);
      modal.toggle();
    }
    ;
  };

  initYoutubeVideo = (videoId) => {
    this.player.stopVideo();
    this.player.clearVideo();
    this.player.cueVideoById(videoId);
  }

  retrieveYoutubeId = (youtubeUrl) => {
    const videoIdRegex = /(youtu\.be\/|youtube(-nocookie)?.com\/(v\/|e\/|.*u\/\w+\/|embed\/|.*v=))([\w-]{11})/;
    const urlMatch = youtubeUrl.match(videoIdRegex);
    return (urlMatch && urlMatch[4].length == 11) ? urlMatch[4] : false;
  };

  onYouTubePlayerAPIReady = () => {
    if (typeof YT !== 'undefined' && YT.loaded) {
      this.player = new YT.Player('player', {
        width: '1280',
        height: '720'
      });
    } else {
      setTimeout(this.onYouTubePlayerAPIReady, 100);
    }
    ;
  }

  loadYoutubeApi = () => {
    this.cookieStatus = this.checkOneTrustCookies();
    if (this.cookieStatus) {
      this.toggleBlockedMessage('none');
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    } else {
      const videoBlockedCtn = document.querySelectorAll(this.videoBlockedMessage);
      videoBlockedCtn.forEach(item => {
        this.toggleBlockedMessage('block');
      })
    }
  }

  toggleBlockedMessage = (type) => {
    const videoBlockedCtn = document.querySelectorAll(this.videoBlockedMessage);
    videoBlockedCtn.forEach(item => {
      item.style.display = type;
    })
  }

  checkOneTrustCookies = () => {
    const arrRequiredOneTrustGroups = ['C0004', 'C0002', 'C0003'];
    let oneTrustRequired = true;
    for (let i = 0; i < arrRequiredOneTrustGroups.length; i++) {
      if (!OnetrustActiveGroups.includes(arrRequiredOneTrustGroups[i])) {
        oneTrustRequired = false;
        break;
      }
    }
    return oneTrustRequired;
  }
}

const modalyoutube = new ModalYoutube();
